.container {
  display: grid;
  place-items: center;
}

.slow {
  --logo-cycle: 3400ms;
  --logo-stagger: 340ms;
}

.medium {
  --logo-cycle: 2200ms;
  --logo-stagger: 220ms;
}

.fast {
  --logo-cycle: 1600ms;
  --logo-stagger: 160ms;
}

.svg {
  width: 72px;
  height: 72px;
}

.sm .svg {
  width: 48px;
  height: 48px;
}

.md .svg {
  width: 72px;
  height: 72px;
}

.lg .svg {
  width: 96px;
  height: 96px;
}

.identBase {
  fill: var(--brand-storm-800);
}

.fill {
  fill: var(--brand-ocean-400);
  opacity: 0.15;
  transform-origin: 50% 100%;
  transform: scaleY(0);
  animation: fillUp var(--logo-cycle, 2200ms) ease-in-out infinite;
  will-change: transform, opacity;
}

.fill1 {
  animation-delay: calc(var(--logo-stagger, 220ms) * 0);
}
.fill2 {
  animation-delay: calc(var(--logo-stagger, 220ms) * 1);
}
.fill3 {
  animation-delay: calc(var(--logo-stagger, 220ms) * 2);
}
.fill4 {
  animation-delay: calc(var(--logo-stagger, 220ms) * 3);
}
.fill5 {
  animation-delay: calc(var(--logo-stagger, 220ms) * 4);
}

@keyframes fillUp {
  0% {
    opacity: 0.15;
    transform: scaleY(0);
  }
  40% {
    opacity: 1;
    transform: scaleY(1);
  }
  70% {
    opacity: 0.55;
    transform: scaleY(1);
  }
  100% {
    opacity: 0.15;
    transform: scaleY(0);
  }
}

/* Long-load mode: fill once; bar 3 crawls after ~half */
.longCharge .fill {
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-duration: 16000ms;
  animation-timing-function: linear;
}

.longCharge .fill1 {
  animation-name: long1;
  animation-delay: 0ms;
}
.longCharge .fill2 {
  animation-name: long2;
  animation-delay: 0ms;
}
.longCharge .fill3 {
  animation-name: long3;
  animation-delay: 0ms;
}
.longCharge .fill4 {
  animation-name: long4;
  animation-delay: 0ms;
}
.longCharge .fill5 {
  animation-name: long5;
  animation-delay: 0ms;
}

@keyframes long1 {
  0% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  10% {
    opacity: 1;
    transform: scaleX(1);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes long2 {
  0% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  18% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  28% {
    opacity: 1;
    transform: scaleX(1);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes long3 {
  0% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  32% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  42% {
    opacity: 0.6;
    transform: scaleX(0.995);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes long4 {
  0% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  74% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  92% {
    opacity: 0.55;
    transform: scaleX(0.995);
  }
  100% {
    opacity: 0.8;
    transform: scaleX(0.998);
  }
}

@keyframes long5 {
  0% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  86% {
    opacity: 0.1;
    transform: scaleX(0.98);
  }
  100% {
    opacity: 0.55;
    transform: scaleX(0.995);
  }
}

@media (prefers-reduced-motion: reduce) {
  .fill {
    animation: none;
    opacity: 0.35;
    transform: scaleY(1);
  }
  .fill1,
  .fill2 {
    opacity: 1;
  }
}

/* Layout wrappers used by useLoadingStatus hook */

.relative {
  position: relative;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(250, 250, 250, 0.8);
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullPage {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
